type PromiseStoreKeyBasicTypeArg = string | number | boolean | object | undefined | null;
type PromiseStoreKeyBasicTypeArrayArg = string[] | number[] | boolean[];
type PromiseStoreKeyArg = PromiseStoreKeyBasicTypeArg | PromiseStoreKeyBasicTypeArrayArg;

let store: Record<string, Promise<any> | undefined> = {};

const computeKey = (keyArgs: PromiseStoreKeyArg[]) => {
    const reducedKeyArgs = keyArgs?.map((keyArg) => {
        if (keyArg != null) {
            if (Array.isArray(keyArg)) {
                const keyArgArray = keyArg as PromiseStoreKeyBasicTypeArrayArg;

                if (keyArgArray.every(k => !isNaN(Number(k)))) {
                    return [...keyArgArray].sort((a, b) => Number(a) - Number(b)).join('-');
                }

                return [...keyArgArray].sort((a, b) => `${a}`.localeCompare(`${b}`)).join('-');
            }

            if (typeof keyArg === 'object') {
                return Object.entries(keyArg)
                    .map(m => `${m[0]}-${m[1]}`)
                    .sort((a, b) => a.localeCompare(b))
                    .join('-');
            }
        }

        return keyArg;
    }) || [];
    return `${reducedKeyArgs.join('_')}`;
};

const get = <T = void>(...keyArgs: PromiseStoreKeyArg[]) => {
    const key = computeKey(keyArgs);
    return store[key] ? store[key] as Promise<T> : undefined;
};

const set = <T>(promise: Promise<T>, ...keyArgs: PromiseStoreKeyArg[]) => {
    const key = computeKey(keyArgs);
    store[key] = promise;
    promise.catch(() => {
        if (store[key] === promise) {
            delete store[key];
        }
    });
};

const getKey = (...keyArgs: PromiseStoreKeyArg[]) => {
    return computeKey(keyArgs);
};

const clear = () => {
    store = {};
};

export const PromiseStore = { get, set, getKey, clear };